/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';
import router from '@/router/index';

const initialState = () => ({
  error: '',
  loading: false,
  user: {},
  popup_reset_password: false,
  project_invites: [],
  user_upgrades: { id: -1},
  user_upgrades_management: [],
  recent_invited_user: [],
  recently_active_user: [],
  user_search: [],
  pro_user: [],
  deactivated_user: [],
  user_activites: {},
  emails_suppressed: []
});

// State object
const state = initialState();
// Getter functions
const getters = {
  isLoading: (state) => state.loading,
  isPopupResetPassword: (state) => state.popup_reset_password,
  getProjectInvites: (state) => state.project_invites,
  getUserUpgrades: (state) => state.user_upgrades,
  getAllUserUpgrades: (state) => state.user_upgrades_management,
  getProUser: (state) => state.pro_user,
  getDeactivatedUser: (state) => state.deactivated_user,
  getEmailSuppressionList: (state) => state.emails_suppressed
};
// Actions
const actions = {
  updateUser({
    commit
  }, payload) {
    commit('set_loading', true);
    axios({
        url: 'users/' + payload.id,
        method: 'PUT',
        data: payload.update
      })
      .then(resp => {
        if (resp.status === 204) {
          commit('View/account_info_edit_mode', false, {
            root: true
          });
          commit('set_loading', false);
        }
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        commit('set_loading', false);
      });
  },
  changePassword({
    commit
  }, payload) {
    commit('set_loading', true);
    axios({
        url: 'users/' + payload.id + '/changepassword',
        method: 'PUT',
        data: payload.passwords
      })
      .then(resp => {
        if (resp.status === 204) {
          commit('View/account_settings_status', 'Password has been changed!', {
            root: true
          });
          commit('set_loading', false);
        }
      })
      .catch(err => {
        commit('View/account_settings_status', err.response.data.error_msg, {
          root: true
        });
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        commit('set_loading', false);
      });
  },
  userImageUpload({
    commit
  }, payload) {
    commit('set_loading', true);
    axios({
        url: 'users/' + payload.id + '/imageupload',
        method: 'POST',
        data: payload.form_data
      })
      .then(resp => {
        let image = resp.data.data.image + '?rand=' + Date.now();
        commit('Auth/update_image', image, {
          root: true
        });
        commit('set_loading', false);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        commit('set_loading', false);
      });
  },
  resetPassword({
    commit
  }, payload) {

    let data = {
      email: payload
    };
    commit('set_loading', true);

    axios({
        url: 'users/passwordreset',
        method: 'POST',
        data: data
      })
      .then(() => {
        commit('set_loading', false);
        commit('set_popup_reset_password', true);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('set_popup_reset_password', true);
        commit('set_loading', false);
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
      });
  },
  setPopupResetPasswordFalse({
    commit
  }) {
    commit('set_popup_reset_password', false);
  },
  requestUserProjectInvites({commit}, id){
    return new Promise((resolve, reject) => {
      axios({
        url: 'users/' + id + '/invites?show=showForUserInvites',
        method: 'GET',
        headers: {
          'cache-control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_user_project_invites', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });

    });
  },
  requestUserActivites({commit}, id){
    return new Promise((resolve, reject) => {
      axios({
        url: 'users/' + id + '/activities',
        method: 'GET',
        headers: {
          'cache-control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_user_activities', {id: id, data: resp.data.data});
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });

    });
  },
  registerAsInvitedUser({commit}, payload){
    axios({
      url: 'users/invited',
      method: 'POST',
      data: {
        password: payload.password,
        email: payload.email,
        phone_number: payload.phone_number,
        first_name: payload.first_name,
        last_name: payload.last_name,
        version_number_main: 1,
        version_number_feature: 1,
        version_number_bug: 1
      }
    })
    .then(resp => {
      commit('View/set_register_as_invited_feedback', {
        state: 'success',
        payload: resp.data.data.first_name
      }, { root: true });
    })
    .catch(err => {
      commit('View/set_register_as_invited_feedback', {
        state: 'error',
        payload: err.response.data.error_msg
      }, { root: true });
    });
  },
  requestUserUpgrades({commit}){
    return new Promise((resolve, reject) => {
      axios({
        url: 'userupgrades',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_user_upgrades', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  requestUserUpgrade({commit}, payload){
    axios({
      url: 'userupgrades',
      method: 'POST',
      data: payload
    })
    .then(resp => {
      commit('set_user_upgrades', resp.data.data);
      router.push({ name: 'AccountSettings' });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  upgradeUserToProUserBusiness({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'userupgrades/0/upgradeprouserbusiness',
        method: 'POST',
        data: payload
      })
      .then(resp => {
        commit('set_user_upgrades', resp.data.data);
        resolve();
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  requestUserUpgradesForManagement({commit}){
    return new Promise((resolve, reject) => {
      axios({
        url: 'userupgrades?all=true',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_user_upgrades_management', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  requestProUser({commit}){
    return new Promise((resolve, reject) => {
      axios({
        url: 'users?pro=true&show=showForProUser',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_pro_user', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  requestDeactivatedUser({commit}){
    return new Promise((resolve, reject) => {
      axios({
        url: 'users?deactivated=true',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_deactivated_user', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  requestRecentInvitedUser({commit}){
    return new Promise((resolve, reject) => {
      axios({
        url: 'users/0/recentinviteduser',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_recent_invited_user', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  requestRecentlyActiveUser({commit}){
    return new Promise((resolve, reject) => {
      axios({
        url: 'users/0/recentlyactiveuser',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_recently_active_user', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  requestUsersByEmail({commit}, email){
    return new Promise((resolve, reject) => {
      axios({
        url: `users?email=${email}&show=showForSearch`,
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_user_search', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  reactivatedUser({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'users/' + payload.id + '/reactivate',
        method: 'PUT',
        data: {},
      })
      .then(() => {
        if (payload.is_search) {
          commit('user_search_update_verified', {
            user_id: payload.id,
            verified: true
          });
        } else {
          commit('remove_deactivated_user', payload.id);
        }
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  deactivateUser({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'users/' + payload.id + '/deactivate',
        method: 'PUT',
        data: {},
      })
      .then(() => {
        if (payload.is_search) {
          commit('user_search_update_verified', {
            user_id: payload.id,
            verified: false
          });
        } else {
          commit('remove_recent_invited_user', payload.id);
          commit('remove_recently_active_user', payload.id);
        }
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  deleteUserUpgrade({commit}, payload){
    axios({
      url: 'userupgrades/' + payload.id,
      method: 'DELETE',
      data: payload.payload
    })
    .then(() => {
      commit('remove_from_user_upgrades_management', payload.id);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  removeProUserRoles({commit}, payload) {
    axios({
      url: 'users/' + payload.user_id + '/removeroles',
      method: 'PUT',
      data: { roles: payload.roles }
    })
    .then(() => {
      commit('remove_users_pro_roles', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  requestEmailSuppressionList({commit}){
    return new Promise((resolve, reject) => {
      axios({
        url: 'takt/bouncy-boys',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_emails_suppressed', resp.data.data);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  DeleteEmailFromSuppressionList({commit}, email){
      axios({
        url: 'takt/bouncy-boys',
        method: 'DELETE',
        headers: {
          'Cache-Control': 'no-cache'
        },
        data: { email: email }
      })
      .then(() => {
        commit('remove_email_from_suppression_list', email);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
      });
  },
};
// Mutations
const mutations = {
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_error(state, err) {
    state.error = err;
  },
  set_loading(state, loading) {
    state.loading = loading;
  },
  set_popup_reset_password(state, boolean){
    state.popup_reset_password = boolean;
  },
  set_user_project_invites(state, invites){
    state.project_invites = invites;
  },
  set_user_upgrades(state, user_upgrades){
    state.user_upgrades = user_upgrades;
  },
  set_pro_user(state, pro_user){
    state.pro_user = [...pro_user];
  },
  set_deactivated_user(state, deactivated_user){
    state.deactivated_user = [...deactivated_user];
  },
  set_recent_invited_user(state, recent_invited_user){
    state.recent_invited_user = [...recent_invited_user];
  },
  set_recently_active_user(state, recently_active_user){
    state.recently_active_user = [...recently_active_user];
  },
  set_user_search(state, user_search){
    state.user_search = [...user_search];
  },
  set_emails_suppressed(state, payload) {
    state.emails_suppressed = [...payload];
  },
  remove_recent_invited_user(state, id){
    const index = state.recent_invited_user.findIndex(function(item) {
      return item.id == id;
    });
    state.recent_invited_user = [
      ...state.recent_invited_user.slice(0, index),
      ...state.recent_invited_user.slice(index + 1)
    ];
  },
  remove_recently_active_user(state, id){
    const index = state.recently_active_user.findIndex(function(item) {
      return item.id == id;
    });
    state.recently_active_user = [
      ...state.recently_active_user.slice(0, index),
      ...state.recently_active_user.slice(index + 1)
    ];
  },
  remove_deactivated_user(state, id){
    const index = state.deactivated_user.findIndex(function(item) {
      return item.id == id;
    });
    state.deactivated_user = [
      ...state.deactivated_user.slice(0, index),
      ...state.deactivated_user.slice(index + 1)
    ];
  },
  set_user_clients(state, user_clients){
    state.user_clients = [...user_clients];
  },
  set_user_upgrades_management(state, user_upgrades_management){
    state.user_upgrades_management = [...user_upgrades_management];
  },
  remove_from_user_upgrades_management(state, id){
    const index = state.user_upgrades_management.findIndex(function(item) {
      return item.id == id;
    });
    state.user_upgrades_management = [
      ...state.user_upgrades_management.slice(0, index),
      ...state.user_upgrades_management.slice(index + 1)
    ];
  },
  remove_invitation(state, invitaion){
    const index = state.project_invites.findIndex(function(item) {
      return item.id == invitaion.id;
    });
    state.project_invites = [
      ...state.project_invites.slice(0, index),
      ...state.project_invites.slice(index + 1)
    ];
  },
  remove_email_from_suppression_list(state, email){
    const index = state.emails_suppressed.findIndex(function(item) {
      return item.EmailAddress == email;
    });
    state.emails_suppressed = [
      ...state.emails_suppressed.slice(0, index),
      ...state.emails_suppressed.slice(index + 1)
    ];
  },
  user_search_update_verified(state, payload) {
    const index = state.user_search.findIndex(function(item) {
      return item.id == payload.user_id;
    });
    state.user_search[index].verified = payload.verified;
  },
  set_user_activities(state, payload) {
    state.user_activites[payload.id] = payload.data;
  },
  remove_users_pro_roles(state, payload) {
    const index = state.pro_user.findIndex(function(item) {
      return item.id == payload.user_id;
    });
    for (let i = 0; i < payload.roles.length; i++) {
      const role_index = state.pro_user[index].pro_user_roles.findIndex(function(item) {
        return item.id == payload.roles[i].id;
      });
      state.pro_user[index].pro_user_roles.splice(role_index, 1);
    }
    if (state.pro_user[index].pro_user_roles.length === 0) {
      state.pro_user.splice(index, 1);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
